import { Dialog, DialogTitle, DialogActions, Button } from "@mui/material";
import { useTranslation } from "../../../../../../hooks/useTranslation";
import { useCustomMutation, useInvalidate } from "@refinedev/core";
import LoadingButton from "@mui/lab/LoadingButton";
import { useMarketplaceStore } from "../../../../../../store/useMarketplaceStore";
import { useParams } from "react-router-dom";

type CancelDialogProps = {
  open: boolean;
  onClose: () => void;
};

export const CancelDialog = ({ open, onClose }: CancelDialogProps) => {
  const { translate, translateWithoutPrefix } = useTranslation(
    "pages.orders.detail.sidebar.orderCancel",
  );
  const selectedCountry = useMarketplaceStore((state) => state.selectedCountry);
  const { orderId } = useParams<{ orderId: string }>();

  const { mutate, isLoading: isSaveLoading } = useCustomMutation();
  const invalidate = useInvalidate();

  const onConfirm = () => {
    mutate(
      {
        url: `store/${selectedCountry?.id}/order/${orderId}/cancel`,
        method: "put",
        values: {},
        successNotification: () => ({
          message: translate("orderCancelledSuccessfully"),
          type: "success",
        }),
      },
      {
        onSuccess: () => {
          invalidate({
            resource: "all",
            invalidates: ["all"],
          });
          onClose();
        },
      },
    );
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{translate("title")}</DialogTitle>

      <DialogActions>
        <Button onClick={onClose}>
          {translateWithoutPrefix("buttons.discard")}
        </Button>
        <LoadingButton
          loading={isSaveLoading}
          color="error"
          variant="contained"
          onClick={() => onConfirm()}
        >
          {translate("confirm")}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
